export { default } from './BackToTopButton'
